import React from 'react'
import { Button } from './Button'
import './Footer.css'
import { Link } from 'react-router-dom'

function Footer() {
  return (
    <div className='footer-container'>
        <div className='footer-all-wrapper'>
            <div className='footer-info-wrapper'>
                <div className='footer-info'>
                    <h2>
                        Shawn Jalali
                    </h2>
                    <p className='footer-info-text'>
                        Real Mortgage Associates<br/>
                        Mortgage Agent L2<br/>
                        RMA #10464<br/>
                        License Number: M11000580<br/>
                        14+ years of experience<br/>
                    </p>
                </div>
            </div>
            
            <div className='footer-links'>
                <div className='footer-link-wrapper'>
                    <div className='footer-link-items'>
                        <h2 className='pages1'>Pages</h2>
                        <Link to='/'>Home</Link>
                        <Link to='/services'>Services</Link>
                        <Link to='/calculator'>Mortgage Calculator</Link>
                        <Link to='/meet-the-team'>About Us</Link>
                        <Link to='/contact'>Contact Us</Link>
                    </div>
                    {/* <div className='footer-link-items'>
                        <h2 className='pages2'>Pages</h2>
                        
                    </div> */}
                </div>
            </div>
            <div className='footer-address-wrapper'>
                <div className='footer-address'>
                    <h2>Get in touch</h2>
                    <div className='footer-address-label'>
                        <i className="fa-solid fa-envelope"></i>
                        <label className='contact-info-label'>
                            shawnmortgage6@gmail.com
                        </label>
                    </div>
                    <div className='footer-address-label'>
                        <i className="fa-solid fa-phone"></i>
                        <label className='contact-info-label'>
                            Office: (289) 271-0358
                        </label>
                    </div>
                    <div className='footer-address-label'>
                        <i className="fa-solid fa-phone"></i>
                        <label className='contact-info-label'>
                            Shawn Jalali: (416) 846-7035
                        </label>
                    </div>
                    <div className='footer-address-label'>
                        <i className="fa-solid fa-location-pin"></i>
                        <label className='contact-info-label'>
                            578 Upper James Street, Hamilton Ontario, L9C 2Y6
                        </label>
                    </div>
                </div>
            </div>
        </div>
            
        
        <section className='social-media'>
            <div className='social-media-wrap'>
                <div className='footer-logo'>
                    {/* <Link to='/' className='social-logo'>
                        RMA <i className='fab fa-typo3'></i>
                    </Link> */}
                    <img className='footer-link-image' src='/images/rmaType2.png'></img>
                </div>
                <small className='website-rights'>Shawn Jalali © 2025</small>
                <div className='social-icons'>
                    <Link className='social-icon-link facebook' to='/' target='_blank' aria-label='Facebook'>
                        <i className='fab fa-facebook-f'></i>
                    </Link>
                    <Link className='social-icon-link instagram' to='/' target='_blank' aria-label='Instagram'>
                        <i className='fab fa-instagram'></i>
                    </Link>
                    <Link className='social-icon-link youtube' to='/' target='_blank' aria-label='Youtube'>
                        <i className='fab fa-youtube'></i>
                    </Link>
                    <Link className='social-icon-link linkedin' to='/' target='_blank' aria-label='LinkedIn'>
                        <i className='fab fa-linkedin'></i>
                    </Link>
                </div>
            </div>
        </section>
    </div>
  )
}

export default Footer